<template>
  <div class="phone-numbers-wrapper">
    <h3 v-show="isTitleShown" class="phone-numbers-title brand-text">
      Want to speak to someone now?
    </h3>
    <div 
      v-for="(label, key) in phoneNumbers" 
      :key="key" 
      class="col-sm-12 phone-numbers-item mb-4"
    >
      <div>
        {{ label }}:
        <a
          :href="generateTelLink(getPhoneNumber(key))"
          class="phone-numbers-link brand-text ml-3"
        >
          {{ getPhoneNumber(key) }}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SHPhoneNumbers",
  props: {
    isTitleShown: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  computed: {
    phoneNumbers() {
      return {
        uk: "UK",
        ie: "IE",
        international: "International",
        sms: "SMS",
        whatsapp: "Whatsapp",
      };
    },
  },
  methods: {
    getPhoneNumber(type) {
      const defaultNumber = "1800 903 542";
      const membership = this.$store.getters.user.simplyhealth_membership;
      return membership ? membership.phone_numbers?.[type] || membership[type] || defaultNumber : defaultNumber;
    },
    generateTelLink(phoneNumber) {
      return `tel:+${phoneNumber.replace(/\s/g, "")}`;
    },
  },
};
</script>

<style lang="less">
.phone-numbers-wrapper {
  .phone-numbers-title {
    padding: 0;
    margin-top: 0;
    margin-bottom: 30px;
    text-align: center;
    font-size: 2.2rem;
    letter-spacing: 0;
    font-family: "PlusJakartaSansBold";
  }

  .phone-numbers-item {
    font-size: 1.8rem;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .phone-numbers-link {
    font-family: "PlusJakartaSansBold";
  }
}
</style>
